
/* injects from baggage-loader */

'use strict';
import $ from 'jquery';
import AlertController from '../alert/alert.controller';

import { failDialg, feedbackFinishStage, feedbackTexts, feedbackTextsChallenge } from './quiz-peixeboi.const';

import { sortBy, shuffle } from 'lodash';


export default class DialogQuizPeixeboiController extends AlertController{
    constructor($log, $rootScope, $timeout, $state, Dialog, Trophies, Session) {
        'ngInject';
        super($log, $rootScope);
        this.$log = $log;
        this.$state = $state;
        this.$timeout = $timeout;
        this.Dialog = Dialog;
        this.Trophies = Trophies;
        this.Session = Session;
        
        this.carousel = null;
        this.image = [require('_images/quiz-peixeboi/conte.png'),require('_images/quiz-peixeboi/responda.png'),require('_images/quiz-peixeboi/responda.png')];
        

        this.answers = {
            q1: {
                error: null,
                value: null
            },
            q2: {
                error: null,
                value: null
            },
            q3: {
                error: null,
                value: null
            },
            q4: {
                error: null,
                value: null
            },
            q5: {
                error: null,
                value: null
            },
            q6: {
                error: null,
                value: null
            },
            q7: {
                error: null,
                value: null
            }
        }

          

        


    }    
    $onInit(){
        this.questions = this.resolve.question;
        this.t = this.image[this.resolve.question-1];
        this.$timeout(this.bindCarousel.bind(this));
        //console.log(this.resolve);

        this.resolve.model = {
            boto: parseInt(this.resolve.model.boto),
            tucunare: parseInt(this.resolve.model.tucunare),
            peixeboi: parseInt(this.resolve.model.peixeboi)
            
        }

        let fishes = [
          { 'fish': 'botos',   'qnt': this.resolve.model.boto },
          { 'fish': 'tucunarés', 'qnt': this.resolve.model.tucunare },
          { 'fish': 'peixes-boi',   'qnt': this.resolve.model.peixeboi }
        ];
        
        

        this.f = sortBy(fishes, ['qnt']);
        this.fRand = shuffle(fishes);
        //console.log(this.resolve.model);
        //console.log(this.resolve.model.boto+this.resolve.model.peixeboi+this.resolve.model.tucunare);
        

    }

    bindCarousel(){
        $('.quiz-carousel').slick({
            infinite: false,
            draggable: false,
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1
        });
    }

    submit(form){
        if(form.$valid){
            if(this.questions === 1){
                this.answers.q1.error = this.q1Val();
                this.answers.q2.error = this.q2Val();
                this.answers.q3.error = this.q3Val();
            }else if(this.questions === 2){
                this.answers.q4.error = this.q4Val();
                this.answers.q5.error = this.q5Val();
            }else if(this.questions === 3){
                this.answers.q6.error = this.q6Val();
                this.answers.q7.error = this.q7Val();
            }

            
            
            let result = null;
            let responses = [];

            angular.forEach(this.answers, value => {
                responses.push(value.error);
            });

            result = responses.filter( error => error === true).length

            

            if(result === 0){

                this.onQuizCorrect();
            } else {
                this.Dialog.showFeedback('label-opa', failDialg, 'btn-ok', ()=> false);
            }
        }
    }

    q1Val(){
        return parseInt(this.answers.q1.value) !== ( this.resolve.model.boto);
    }

    q2Val(){
        return parseInt(this.answers.q2.value) !== ( this.resolve.model.peixeboi);
    }

    q3Val(){
        return parseInt(this.answers.q3.value) !== ( this.resolve.model.tucunare);
    }

    q4Val(){

        return parseInt(this.answers.q4.value) !== ( this.f[2].qnt - this.f[0].qnt);
    }

    q5Val(){
        return parseInt(this.answers.q5.value) !== ( this.fRand[0].qnt + this.fRand[1].qnt);
    }

    q6Val(){
        return parseInt(this.answers.q6.value) !== ( this.fRand[2].qnt + this.fRand[0].qnt);
    }


    q7Val(){
        return parseInt(this.answers.q7.value) !== ( this.resolve.model.boto+this.resolve.model.peixeboi+this.resolve.model.tucunare);
    }


    

    onQuizCorrect () {
        if(this.questions === 3){
            //console.log("Questão 4? "+this.questions);
            this.Trophies.collectThrophies('default', 'peixeboi');
            this.Trophies.collectThrophies('emblem', 'peixeboi');
            this.$timeout(this.ok.bind(this), 600); //Fechar Modal
            this.Dialog.showTrophy('peixeboi', feedbackFinishStage, () => {
                let infos = this.Session.get();
                infos.stages[0].totalCompleted++;
                this.Session.save(infos);
                 this.$state.go('main');
            });

        }else if(this.questions === 2){
            this.Dialog.showFeedback('label-congratulations', feedbackTextsChallenge, 'btn-ok', () => {
                this.$timeout( () => {
                    this.ok();
                    // Notificando Peixeboi Stage
                    this.$rootScope.$emit('finish:peixeboi:step1', true)
                },600);
              })
        }else if(this.questions === 1){
           this.Dialog.showFeedback('label-congratulations', feedbackTexts, 'btn-ok', () => {
                this.$timeout(this.ok.bind(this), 600);
                this.$timeout(() => {
                  this.Dialog.showQuizPeixeboi(2, this.resolve.model, () => false);
                }, 1200);
              })
           
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/dialogs/quiz-peixeboi/quiz-peixeboi.controller.js